const dashboard = {
  en: {
    'dashboard.welcome': 'Welcome back',
    'dashboard.loadError': 'Failed to load dashboard data',
    'dashboard.currentTime': 'Current Time',
    'dashboard.activeTimer': 'Active Timer',
    'dashboard.elapsedTime': 'Elapsed Time',
    'dashboard.thisWeek': 'This Week',
    'dashboard.activeProjects': 'Active Projects',
    'dashboard.totalClients': 'Total Clients',
    'dashboard.thisMonth': 'This Month',
    'dashboard.today': 'Today',
    'dashboard.recentActivity': 'Recent Activity',
    'dashboard.noRecentActivity': 'No recent activity',
    'dashboard.upcomingDeadlines': 'Upcoming Deadlines',
    'dashboard.due': 'Due',
    'dashboard.noUpcomingDeadlines': 'No upcoming deadlines',
    'dashboard.quickActions': 'Quick Actions',
    'dashboard.startTimer': 'Start Timer',
    'dashboard.newProject': 'New Project',
    'dashboard.addClient': 'Add Client',
    'dashboard.createInvoice': 'Create Invoice',
  },

  es: {
    'dashboard.welcome': 'Te damos la bienvenida de nuevo',
    'dashboard.loadError': 'No se pudieron cargar los datos del panel',
    'dashboard.currentTime': 'Hora actual',
    'dashboard.activeTimer': 'Temporizador activo',
    'dashboard.elapsedTime': 'Tiempo transcurrido',
    'dashboard.thisWeek': 'Esta semana',
    'dashboard.activeProjects': 'Proyectos activos',
    'dashboard.totalClients': 'Clientes totales',
    'dashboard.thisMonth': 'Este mes',
    'dashboard.today': 'Hoy',
    'dashboard.recentActivity': 'Actividad reciente',
    'dashboard.noRecentActivity': 'Sin actividad reciente',
    'dashboard.upcomingDeadlines': 'Próximas fechas límite',
    'dashboard.due': 'Vence',
    'dashboard.noUpcomingDeadlines': 'Sin fechas límite próximas',
    'dashboard.quickActions': 'Acciones rápidas',
    'dashboard.startTimer': 'Iniciar temporizador',
    'dashboard.newProject': 'Nuevo proyecto',
    'dashboard.addClient': 'Agregar cliente',
    'dashboard.createInvoice': 'Crear factura',
  },
};

export default dashboard;
